// extracted by mini-css-extract-plugin
export default {"app__about":"styles_app__about__EUpJm","app__profiles":"styles_app__profiles__6kF40","app__profile_item":"styles_app__profile_item__gIVJa"};